import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { IRole } from "./roles.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class RolesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getRoles(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_ROLES)}${queryParams}`);
  }

  getRole(role: IRole | string): Observable<any> {
    let id = (typeof role == 'string') ? role : role._id;
    return this._http.get(`${apiURL(EnvConfig.API_ROLES)}/${id}`);
  }

  createRole(role: IRole): Observable<any> {
    delete role._id;
    return this._http.post(`${apiURL(EnvConfig.API_ROLES)}`, role);
  }

  updateRole(role: IRole): Observable<any> {
    let id = role._id;
    delete role._id;
    return this._http.patch(`${apiURL(EnvConfig.API_ROLES)}/${id}`, role);
  }

  deleteRole(role: IRole | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof role == 'string') ? role : role._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_ROLES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_ROLES)}/${id}/delete`);
  }

  restoreRole(role: IRole | string): Observable<void> {
    let id = (typeof role == 'string') ? role : role._id;
    return this._http.post(`${apiURL(EnvConfig.API_ROLES)}/${id}/restore`, null);
  }
}